import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { System } from '@app/core/resources/system';
import { SystemsService } from '@app/core/services/systems.service';

@Component({
    selector: 'app-systems-alternatives',
    templateUrl: './systems-alternatives.component.html',
    styleUrls: ['./systems-alternatives.component.scss']
})
export class SystemsAlternativesComponent implements OnChanges {
    @Input() public system: System = new System();
    @Input() public systemsId: Array<string> = [];
    public alternativeSystem: Array<System> = [];

    public constructor(private systemService: SystemsService, private router: Router, private changeDetectorRef: ChangeDetectorRef) {}

    public ngOnChanges(): void {
        this.createArraySystem();
        this.changeDetectorRef.markForCheck();
    }

    private createArraySystem(): void {
        this.alternativeSystem = [];
        this.systemsId.forEach((element: any) => {
            this.alternativeSystem.push(this.systemService.createResource(element));
        });
    }

    public redirectLandingBySystem(system: System): void {
        this.router.navigate(['comprar-vender/' + system.id]);
    }
}
